// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedVocabType {
  Compact: {"enum_constant":"Compact"};
  Simple: {"enum_constant":"Simple"};
}

export type VocabTypeId = keyof IParsedVocabType;
export type VocabTypeData = IParsedVocabType[VocabTypeId];
const data: VocabTypeData[] = [{"enum_constant":"Compact"},{"enum_constant":"Simple"}];
export default data;
